
<div class="flow-user-profile" :shape="shape" :style="styleObj">
	<slot>
		<span
			class="flow-user-profile-label"
			:style="{ fontSize: size / 2.5 + 'px', lineHeight: size / 3 + 'px' }"
		>
			{{ title }}
		</span>
	</slot>
</div>
